export const hobbies = ['Viajes', 'Musica', 'Ciclismo', 'Futbol', 'Natación', 'Pescadería', 'Trotar', 'Voleibol']